export interface ApiError extends Error {
    response?: {
      status?: number;
    };
}

export const handleApiError = (err: any, setError: (message: string) => void): boolean => {
    const apiError = err as ApiError;
    if (apiError.response && apiError.response.status) {
      switch (apiError.response.status) {
        case 400:
          setError("Oops! It seems like the information provided wasn't correct. Please check and try again.");
          break;
        case 401:
          setError("Sorry! You're not authorized. Maybe you entered the wrong credentials?");
          break;
        case 404:
          setError("Hmm! We couldn't find what you're looking for. Please try again.");
          break;
        case 500:
          setError("Oh no! We've encountered an internal issue. We're working on it. Please try again later.");
          break;
        default:
          setError("Uh-oh! Something unexpected happened. Please try logging in again.");
      }
      return true;
    }
    setError("Uh-oh! Something unexpected happened. Please try logging in again.");
    return false;
};
